import './InfoIcon.scss';
import { ReactComponent as IconSmall } from '../BootstrapIcons/info-small.svg';
import { ReactComponent as Icon } from '../BootstrapIcons/info.svg';
import React from 'react';

interface Props {
    info: string;
    isSmallSize?: boolean;
}

class InfoIcon extends React.Component<Props> {

    render(): JSX.Element {

        return (
            <span className="info-icon" onClick={async () => await navigator.clipboard.writeText(this.props.info)} title={this.props.info}>
                {this.props.isSmallSize ?
                    <IconSmall />
                    : <Icon />
                }
            </span>
        );
    }
}

export default InfoIcon;
